import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbsoluteValue, Picker, QuickValue, RelativeValue, TimePicker} from './interface/TimePicker';

@Component({
  selector: 'c-time-picker',
  templateUrl: './time-picker.component.html',
  styles: []
})
export class TimePickerComponent implements OnInit {

  @Input() set cTimePicker(timePicker: Array<TimePicker>) {
    this.timePickers = timePicker;
  }

  @Input() set cTime(value) {
    if (!value) {
      return;
    }
    this.currentIndex = value.type;
    switch (this.currentIndex) {
      case 0:
        this.quickTime = value;
        break;
      case 1:
        this.absoluteTime = value;
        break;
      case 2:
        this.relativeTime = value;
        break;
    }

  }

  @Output() cChangeTime: EventEmitter<Picker> = new EventEmitter<Picker>();

  public currentIndex = 0;

  public timePickers: Array<TimePicker>;

  public quickTime: QuickValue;

  public absoluteTime: AbsoluteValue;

  public relativeTime: RelativeValue;

  constructor() {
    this.init();
    this.timePickers = [];
  }

  ngOnInit() {
  }

  public selectTime(event) {
    this.cChangeTime.emit(event);
  }


  private init() {
    this.quickTime = {
      type: 0,
      step: 0,
      particle: 'all'
    };
    this.absoluteTime = {
      startTime: new Date().getTime(),
      endTime: new Date().getTime(),
      type: 1
    };
    this.relativeTime = {
      type: 2,
      step: 0,
      particle: 'second',
      abs: -1
    };
  }

}
